
export const AccessLevel = {
  OWNER: 50,
  CO_OWNER: 40,
  WORKER: 30,
  OBSERVER: 20,
  GUEST: 10,
}

export class SiteMember {

accessLevels() {
  return [
    {value: AccessLevel.OWNER ,text: this.accessLevelName(AccessLevel.OWNER)},
    {value: AccessLevel.CO_OWNER ,text: this.accessLevelName(AccessLevel.CO_OWNER)},
    {value: AccessLevel.WORKER ,text: this.accessLevelName(AccessLevel.WORKER)},
    {value: AccessLevel.OBSERVER ,text: this.accessLevelName(AccessLevel.OBSERVER)},
    {value: AccessLevel.GUEST ,text: this.accessLevelName(AccessLevel.GUEST)}
  ]
}

accessLevelName(value) {
  switch(value) {
    case AccessLevel.OWNER: return "Właściciel"
    case AccessLevel.CO_OWNER: return "Współwłaściciel"
    case AccessLevel.WORKER: return "Pracownik"
    case AccessLevel.OBSERVER: return "Obserwator"
    case AccessLevel.GUEST: return "Gość"
  }
}

}

export default new SiteMember()